import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SortOptions } from '../../pipes/sort-by.pipe';

export interface Row {
  template: object;
}

@Directive()
export abstract class TableDirective<T> implements AfterViewInit, OnDestroy {
  protected destroyed$ = new Subject<void>();

  @Input() elevated = false;
  @Input() scrollable = false;
  @Input() searchTerm = '';
  @Input() searchCols: string[] = [];

  @ViewChild('body') tableBodyElement!: ElementRef<HTMLElement>;

  isBodyOverflown = false;
  mutationObserver!: MutationObserver;

  filteredItems$ = new BehaviorSubject<number>(0);
  sortOptions$ = new BehaviorSubject<SortOptions>({
    property: '',
    direction: 'asc',
  });

  abstract data: T[];
  abstract dataRow: Row;
  abstract emptyRow?: Row;
  abstract headerRow?: Row;

  ngAfterViewInit(): void {
    if (this.scrollable) {
      this.mutationObserver = new MutationObserver(() => {
        const { scrollHeight, clientHeight } = this.tableBodyElement.nativeElement;

        this.isBodyOverflown = scrollHeight > clientHeight;
      });

      this.mutationObserver.observe(this.tableBodyElement.nativeElement, {
        childList: true,
      });
    }
  }

  sortBy(prop: string): void {
    const { property, direction } = this.sortOptions$.value;

    if (property === prop) {
      if (direction === 'asc') {
        this.sortOptions$.next({ property, direction: 'desc' });
      } else if (direction === 'desc') {
        this.sortOptions$.next({ property: '', direction: 'asc' });
      }
    } else {
      this.sortOptions$.next({ property: prop, direction: 'asc' });
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.mutationObserver?.disconnect();
  }
}
